export default __webpack_public_path__ + "static/media/skillSet.ec7e7659.png";